import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import HttpClient from "../../libs/http";
const http = new HttpClient()

export default class Topbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
    }
  }
  async componentWillMount() {
    await this.getData()
  }
  async getData() {
    const _state = this.state
    _state.user = await http.GET('/api/pvt/users/current')
    this.setState(_state)
  }
  render() {
    if (!this.state.user) return false
    return (
      <header className="bg-black-90 w-100 pv1 pv2-ns ph1 ph1-m ph3-l topbar">
        <nav className="dt w-100 border-box">
          <div className="dtc v-mid w-75 ttu">
            <Link className="link dim f6 f5-ns dib white mr3 mr4-ns" to="/">Orders</Link>
            <Link className="link dim f6 f5-ns dib white mr3 mr4-ns" to="/healthcheck">Healthcheck</Link>
          </div>
          <div className="dtc v-mid w-25 tr" href="/" title={this.state.user.name}>
            <div className="white dib mr3 f6 f5-ns">
              <span className="f6 db">{this.state.user.email}</span>
              <span className="f6 db">{this.state.user.name}</span>
              { 
                this.state.user.email==="anonymous@vtex.com" 
                ? <a className="link dim f6 db dib white" href={`https://rely.vtex.com/auth/api/authenticator/login?state=${window.location.href}`}>Sign in</a> 
                : ''
              }
            </div>
            <img src={this.state.user.image} className="dib w2 h2 br-100 mb1" alt={this.state.user.name} />
          </div>
        </nav>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Topbar/index.js